import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {useParams} from 'react-router-dom';
import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const IndexPage = ({ productId, customerId, priceId }: { productId?: string, customerId?: string, priceId?: string }) => {
    const urlId = useParams().id;
    
    // Only use URL ID for productId if we're not in customer or price context
    const finalProductId = productId || (!customerId && !priceId ? urlId : undefined);
    
    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader />}
        >
            <SimplePageContentWrapper>
                <RecordsTable productId={finalProductId} customerId={customerId} priceId={priceId}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};